import { useEffect } from 'react';

const InterviewCoverStatic = () => {
  useEffect(() => {
    // 直接重定向到静态HTML页面
    window.location.href = '/interview-cover.html';
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600 mx-auto mb-4"></div>
        <p className="text-gray-600">正在跳转到面试封面生成器...</p>
      </div>
    </div>
  );
};

export default InterviewCoverStatic;
